export default __webpack_public_path__ + "static/media/bpt-graw.a2a9aba2.png";